import {
  type AnchorHTMLAttributes,
  type ButtonHTMLAttributes,
  type ReactNode,
} from 'react'
import { Icon } from '../Icon/Icon'
import styles from './Button.module.scss'

type ButtonVariant = 'green' | 'outline' | 'primary' | 'white'

interface CommonProps {
  animated?: boolean
  arrow?: boolean
  children: ReactNode
  hoverBlend?: boolean
  variant?: ButtonVariant
}

type ButtonProps = CommonProps & ButtonHTMLAttributes<HTMLButtonElement> & { href?: undefined }

type LinkProps = CommonProps & AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }

export const Button = ({
  animated = false,
  arrow = false,
  children,
  className = '',
  hoverBlend = false,
  variant = 'primary',
  ...rest
}: ButtonProps | LinkProps) => {
  const content = (
    <>
      <span className={styles.label}>{children}</span>
      {arrow ? <Icon className={styles.arrow} name="arrow-right" size={16} /> : null}
    </>
  )
  const rootClassName = `${styles.button} ${styles[variant]}${animated ? ` ${styles.animated}` : ''}${hoverBlend ? ` ${styles.hoverBlend}` : ''} ${className}`.trim()

  if (typeof rest.href === 'string') {
    const { href, target = '_blank', rel = 'noopener noreferrer', ...anchorProps } = rest

    return (
      <a className={rootClassName} href={href} rel={rel} target={target} {...anchorProps}>
        {content}
      </a>
    )
  }

  const { type = 'button', ...buttonProps } = rest

  return (
    <button className={rootClassName} type={type} {...buttonProps}>
      {content}
    </button>
  )
}
